import React from 'react';
import TextInput from './TextInput';

export default function TextInputWithLabel(props) {
  return (
    <TextInput {...props} withLabel />
  );
}
